import { Box, Button, Icon, SpaceBetween } from '@amzn/awsui-components-react';
import { useHistory } from 'react-router-dom';

// TO DO: move all molecules to the global molecules folder once event templates is merged

import { Meta } from '@/src/components/common/Meta';
import { RoutePath } from '@/src/RoutePath';

import { i18nKeys } from '@/src/utils/i18n.utils';
import { useTranslation } from 'react-i18next';
import { aboutAwsJamVideo } from '@/src/utils/jam-urls';
import BookEventSteps from '../molecules/BookEventSteps/BookEventSteps';
import FooterLinks from '../molecules/FooterLinks/FooterLinks';
import MeetAwsJam from '../molecules/MeetAwsJam/MeetAwsJam';
import RealReviews from '../molecules/RealReviews/RealReviews';
import './HomePage.scss';

const EventDisplayContent: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className="discover-events">
      <SpaceBetween size="xxxs" alignItems="center" direction="vertical">
        <Box variant="h2" fontSize="display-l">
          {t(i18nKeys.catalog.discoverEvents)}
        </Box>
        <Box variant="p">{t(i18nKeys.catalog.discoverEventsCaption)}</Box>
      </SpaceBetween>
      <div className="discover-events__browse-all">
        <Button
          href={RoutePath.JOIN_AN_EVENT}
          onFollow={() => {
            history.push(RoutePath.JOIN_AN_EVENT);
          }}
        >
          {t(i18nKeys.catalog.browseAllEvents)}
        </Button>
      </div>
    </div>
  );
};

const HomePage = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const redirectToJoinEvent = () => {
    history.push(RoutePath.JOIN_AN_EVENT);
  };

  return (
    <div className="home-page-container">
      <Meta title={t(i18nKeys.meta.home.title)} />
      <div className="home-cover__outer" style={{ backgroundImage: "url('/assets/homepage-bg.png')" }}>
        <div className="home-cover">
          <div className="text-container">
            <Box fontWeight="light" padding={{ bottom: 'xl' }}>
              <span className="home-cover__category">{t(i18nKeys.catalog.banner.trainingAndCertification)}</span>
            </Box>
            <Box variant="h1" fontWeight="heavy" fontSize="display-l" color="inherit">
              {t(i18nKeys.catalog.banner.awsJam)}
            </Box>
            <Box variant="p" fontWeight="light" padding={{ bottom: 's' }} color="inherit">
              <span className="header-cover__sub-title">{t(i18nKeys.catalog.banner.handsOnLearning)}</span>
            </Box>
            <div className="home-cover__caption">
              <Box fontWeight="light" padding={{ bottom: 'xl' }}>
                <span className="home-cover__header-caption">
                  {t(i18nKeys.catalog.banner.awsJamCaption)}{' '}
                  <a
                    href={aboutAwsJamVideo}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: 'inline', whiteSpace: 'nowrap', color: '#539fe5', textDecoration: 'none' }}
                  >
                    <Icon name="caret-right-filled" /> {t(i18nKeys.catalog.banner.learnMore)}
                  </a>
                </span>
              </Box>
            </div>

            <Box padding={{ bottom: 'xxl' }}>
              <Box display="inline-block" padding={{ bottom: 'l' }}>
                <Button variant="normal" data-testid="secondary-button" onClick={redirectToJoinEvent}>
                  {t(i18nKeys.catalog.joinAnEvent)}
                </Button>
              </Box>
            </Box>
          </div>
          {/* <AnimatedIllustration illustrations={trendingEventTemplates} /> */}
        </div>
        <div className="homepage-hero">
          <div className="homepage-hero__image" style={{ backgroundImage: "url('/assets/Homepage-hero.png')" }} />
        </div>
      </div>
      <div className="book-event">
        <BookEventSteps />
      </div>
      <EventDisplayContent />
      <div className="meet-aws-jam">
        <MeetAwsJam />
      </div>
      <div className="real-reviews-container">
        <RealReviews />
      </div>
      <div className="footer-links-container">
        <FooterLinks />
      </div>
    </div>
  );
};

export default HomePage;
